import "./PrivacyPolicy.scss";

import { Button, Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const onBack = () => {
    navigate("/login");
  };
  return (
    <>
      <div className="header">
        <div
          className="sky"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}></div>
        <div className="sea">
          <Button
            ml={100}
            variant="white"
            color="transparent"
            leftSection={<IconChevronLeft size="1.3rem" />}
            onClick={onBack}>
            Back
          </Button>
        </div>
        <img className="logotype" src="./assets/eLogLogoV2.png"></img>
      </div>
      <div style={{ padding: "50px 100px 50px 100px" }}>
        <Text fz="md" fw="500">
          Who we are:
        </Text>
        <Text fz="sm" mt={15} ml={40}>
          Our website address is:{" "}
          <a
            style={{ color: "blue" }}
            href="https://www.lizjackson.co.uk"
            target="blank">
            https://www.lizjackson.co.uk.
          </a>
        </Text>
        <Text fz="lg" fw={500} mt={25}>
          1. POLICY STATEMENT
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            1.1. Everyone has rights with regard to the way in which their
            personal data in handled. During the course of our activities we
            will collect, store and process personal data about our customers,
            suppliers and other third parties, and we recognise that the correct
            and lawful treatment of this data will maintain confidence in the
            organisation and will provide for successful business operations.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            1.2. Data users are obliged to comply with this policy when
            processing personal data on our behalf. Any breach of this policy
            may result in disciplinary action.
          </Text>
        </div>

        <Text fz="lg" fw={500} mt={25}>
          2. ABOUT THIS POLICY
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            2.1. The types of personal data that Elizabeth Jackson Holdings
            Limited (“We”) may be required to handle include information about
            current, past and prospective suppliers, customers and others that
            we communicate with. The personal data, which may be held on paper
            or on a computer or other media, is subject to certain legal
            safeguards specified in the Data Protection Act 1998 (the Act) and
            other regulations.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            2.2. This policy and any other documents referred to in it sets out
            the basis on which we will process any personal data we collect from
            data subjects, or that is provided to us by data subjects or other
            sources.
          </Text>
          <Text fz="sm" mt={10}></Text>
          <Text fz="sm" mt={15}>
            {" "}
            2.3. This policy does not form part of any employee's contract of
            employment and may be amended at any time.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            2.4. This policy has been approved by the board of directors. It
            sets out rules on data protection and the legal conditions that must
            be satisfied when we obtain, handle, process, transfer and store
            personal data.
          </Text>
          <Text fz="sm" mt={10}></Text>
          <Text fz="sm" mt={15}>
            {" "}
            2.5. The Data Protection Compliance Manager is responsible for
            ensuring compliance with the Act and with this policy. That post is
            held by Liz Jackson, Company Owner, 00(44)7802383262
            hello@lizjackson.co.uk .Any questions about the operation of this
            policy or any concerns that the policy has not been followed should
            be referred in the first instance to the Data Protection Compliance
            Manager.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          3. DEFINITION OF DATA PROTECTION TERMS
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            3.1. Data is information which is stored electronically, on a
            computer, or in certain paper-based filing systems.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.2. Data subjects for the purpose of this policy include all living
            individuals about whom we holds personal data. A data subject need
            not be a UK national or resident. All data subjects have legal
            rights in relation to their personal information.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.3. Personal data means data relating to a living individual who
            can be identified from that data (or from that data and other
            information in our possession). Personal data can be factual (for
            example, a name, address or date of birth) or it can be an opinion
            about that person, their actions and behaviour.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.4. Data controllers are the people who or organisations which
            determine the purposes for which, and the manner in which, any
            personal data is processed. They are responsible for establishing
            practices and policies in line with the Act. We are the data
            controller of all personal data used in our business for our own
            commercial purposes.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.5. Data users are those of our employees whose work involves
            processing personal data. Data users must protect the data they
            handle in accordance with this data protection policy and any
            applicable data security procedures at all times.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.6. Data processors include any person or organisation that is not
            a data user that processes personal data on our behalf and on our
            instructions. Employees of data controllers are excluded from this
            definition but it could include suppliers which handle personal data
            on our behalf.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.7. Processing is any activity that involves use of the data. It
            includes obtaining, recording or holding the data, or carrying out
            any operation or set of operations on the data including organising,
            amending, retrieving, using, disclosing, erasing or destroying it.
            Processing also includes transferring personal data to third
            parties.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            3.8. Sensitive personal data includes information about a person's
            racial or ethnic origin, political opinions, religious or similar
            beliefs, trade union membership, physical or mental health or
            condition or sexual life, or about the commission of, or proceedings
            for, any offence committed or alleged to have been committed by that
            person, the disposal of such proceedings or the sentence of any
            court in such proceedings. Sensitive personal data can only be
            processed under strict conditions, including a condition requiring
            the express permission of the person concerned.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          4. DATA PROTECTION PRINCIPLES
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            Anyone processing personal data must comply with the eight
            enforceable principles of good practice. These provide that personal
            data must be:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) Processed fairly and lawfully.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) Processed for limited purposes and in an appropriate way.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) Adequate, relevant and not excessive for the purpose.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (d) Accurate.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (e) Not kept longer than necessary for the purpose.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (f) Processed in line with data subjects' rights.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (g) Secure.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (h) Not transferred to people or organisations situated in countries
            without adequate protection.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          5. FAIR AND LAWFUL PROCESSING
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            5.1. The Act is not intended to prevent the processing of personal
            data, but to ensure that it is done fairly and without adversely
            affecting the rights of the data subject.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            5.2. For personal data to be processed lawfully, they must be
            processed on the basis of one of the legal grounds set out in the
            Act. These include, among other things, the data subject's consent
            to the processing, or that the processing is necessary for the
            performance of a contract with the data subject, for the compliance
            with a legal obligation to which the data controller is subject, or
            for the legitimate interest of the data controller or the party to
            whom the data is disclosed. When sensitive personal data is been
            processed, additional conditions must be met. When processing
            personal data as data controllers in the course of our business, we
            will ensure that those requirements are met.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          6. PROCESSING FOR LIMITED PURPOSES
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            6.1. In the course of our business, we may collect and process
            personal data. This may include data we receive directly from a data
            subject (for example, by completing forms or by corresponding with
            us by mail, phone, email or otherwise) and data we receive from
            other sources (including, for example, business partners,
            sub-contractors in technical, payment and delivery services, credit
            reference agencies and others).
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            6.2. We will only process personal data for the specific purposes
            which we have notified data subjects of or for any other purposes
            specifically permitted by the Act. We will notify those purposes to
            the data subject when we first collect the data or as soon as
            possible thereafter.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          7. NOTIFYING DATA SUBJECTS
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            7.1. If we collect personal data directly from data subjects, we
            will inform them about:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) The purpose or purposes for which we intend to process that
            personal data.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) The types of third parties, if any, with which we will share or
            to which we will disclose that personal data.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) The means, if any, with which data subjects can limit our use
            and disclosure of their personal data.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            7.2. If we receive personal data about a data subject from other
            sources, we will provide the data subject with this information as
            soon as possible thereafter.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            7.3. We will also inform data subjects whose personal data we
            process that we are the data controller with regard to that data,
            [and who the Data Protection Compliance Manager is].
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          8. ADEQUATE, RELEVANT AND NON-EXCESSIVE PROCESSING
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            We will only collect personal data to the extent that it is required
            for the specific purpose notified to the data subject.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          9. ACCURATE DATA
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            We will ensure that personal data we hold is accurate and kept up to
            date. We will check the accuracy of any personal data at the point
            of collection and at regular intervals afterwards. We will take all
            reasonable steps to destroy or amend inaccurate or out-of-date data.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          10. TIMELY PROCESSING
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            We will not keep personal data longer than is necessary for the
            purpose or purposes for which they were collected. We will take all
            reasonable steps to destroy, or erase from our systems, all data
            which is no longer required.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          11. PROCESSING IN LINE WITH DATA SUBJECT'S RIGHTS
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            We will process all personal data in line with data subjects'
            rights, in particular their right to:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) Request access to any data held about them by a data controller
            (see also clause 15).
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) Prevent the processing of their data for direct-marketing
            purposes.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) Ask to have inaccurate data amended (see also clause 9).
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (d) Prevent processing that is likely to cause damage or distress to
            themselves or anyone else.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          12. DATA SECURITY
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            12.1. We will take appropriate security measures against unlawful or
            unauthorised processing of personal data, and against the accidental
            loss of, or damage to, personal data.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            12.2. We will put in place procedures and technologies to maintain
            the security of all personal data from the point of collection to
            the point of destruction. Personal data will only be transferred to
            a data processor if he agrees to comply with those procedures and
            policies, or if he puts in place adequate measures himself.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            12.3. We will maintain data security by protecting the
            confidentiality, integrity and availability of the personal data,
            defined as follows:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) Confidentiality means that only people who are authorised to use
            the data can access it.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) Integrity means that personal data should be accurate and
            suitable for the purpose for which it is processed.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) Availability means that authorised users should be able to
            access the data if they need it for authorised purposes. Personal
            data should therefore be stored on the Elizabeth Jackson Holdings
            central computer system instead of individual PCs.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            12.4. Security procedures include:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) Entry controls. Any stranger seen in entry-controlled areas
            should be reported.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) Secure lockable desks and cupboards. Desks and cupboards should
            be kept locked if they hold confidential information of any kind.
            (Personal information is always considered confidential.)
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) Methods of disposal. Paper documents should be shredded. Digital
            storage devices should be physically destroyed when they are no
            longer required.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (d) Equipment. Data users must ensure that individual monitors do
            not show confidential information to passers-by and that they log
            off from their PC when it is left unattended.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          13. TRANSFERRING PERSONAL DATA TO A COUNTRY OUTSIDE THE EEA
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            13.1. We may transfer any personal data we hold to a country outside
            the European Economic Area (\"EEA\"), provided that one of the
            following conditions applies:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) The country to which the personal data are transferred ensures
            an adequate level of protection for the data subjects' rights and
            freedoms.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) The data subject has given his consent.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (c) The transfer is necessary for one of the reasons set out in the
            Act, including the performance of a contract between us and the data
            subject, or to protect the vital interests of the data subject.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (d) The transfer is legally required on important public interest
            grounds or for the establishment, exercise or defence of legal
            claims.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (e) The transfer is authorised by the relevant data protection
            authority where we have adduced adequate safeguards with respect to
            the protection of the data subjects' privacy, their fundamental
            rights and freedoms, and the exercise of their rights.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            13.2. Subject to the requirements in clause 13.1 above, personal
            data we hold may also be processed by staff operating outside the
            EEA who work for us or for one of our suppliers. That staff maybe
            engaged in, among other things, the fulfilment of contracts with the
            data subject, the processing of payment details and the provision of
            support services.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          14. DISCLOSURE AND SHARING OF PERSONAL INFORMATION
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            14.1. We may share personal data we hold with any member of our
            group, which means our subsidiaries, our ultimate holding company
            and its subsidiaries, as defined in section 1159 of the UK Companies
            Act 2006.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            14.2. We may also disclose personal data we hold to third parties:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) In the event that we sell or buy any business or assets, in
            which case we may disclose personal data we hold to the prospective
            seller or buyer of such business or assets.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) If we or substantially all of our assets are acquired by a third
            party, in which case personal data we hold will be one of the
            transferred assets.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            14.3. If we are under a duty to disclose or share a data subject's
            personal data in order to comply with any legal obligation, or in
            order to enforce or apply any contract with the data subject or
            other agreements; or to protect our rights, property, or safety of
            our employees, customers, or others. This includes exchanging
            information with other companies and organisations for the purposes
            of fraud protection and credit risk reduction.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            14.4. We may also share personal data we hold with selected third
            parties where necessary to assist us in providing services to you
            and (where you have agreed) for them to provide you with information
            about their services.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          15. DEALING WITH SUBJECT ACCESS REQUESTS
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            15.1. Data subjects must make a formal request for information we
            hold about them. This must be made in writing. Employees who receive
            a written request should forward it to their line manager
            immediately.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            15.2. When receiving telephone enquiries, we will only disclose
            personal data we hold on our systems if the following conditions are
            met:
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (a) We will check the caller's identity to make sure that
            information is only given to a person who is entitled to it.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            (b) We will suggest that the caller put their request in writing if
            we are not sure about the caller’s identity and where their identity
            cannot be checked.
          </Text>
          <Text fz="sm" mt={15}>
            {" "}
            15.3. Our employees will refer a request to their line manager [or
            the Data Protection Compliance Manager] for assistance in difficult
            situations. Employees should not be bullied into disclosing personal
            information.
          </Text>
        </div>
        <Text fz="lg" fw={500} mt={25}>
          16. CHANGES TO THIS POLICY
        </Text>
        <div style={{ marginLeft: "40px" }}>
          <Text fz="sm" mt={15}>
            {" "}
            We reserve the right to change this policy at any time. Where
            appropriate, we will notify data subjects of those changes by mail
            or email.
          </Text>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
